import { render, staticRenderFns } from "./FooterPermanent.vue?vue&type=template&id=bf7eddc6&"
import script from "./FooterPermanent.vue?vue&type=script&lang=js&"
export * from "./FooterPermanent.vue?vue&type=script&lang=js&"
import style0 from "./FooterPermanent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports